import { isEmpty } from 'lodash';
import React from 'react';

import appleBlackLogoSrc from '@assets/images/apple_black_logo.svg';

export default function MarketingLeadCaptureWithApple({
  eventName,
  returningUri,
  verificationUri,
  formLocation,
}: {
  eventName: string;
  formLocation: string;
  leadType: string;
  returningUri?: string;
  verificationUri: string;
}) {
  const appleId = window['AppleID'];
  const appleIdScriptLoaded = !isEmpty(appleId);

  if (!appleIdScriptLoaded) return null;

  return (
    <button
      id="apple-btn-container"
      className="btn-google-signin relative flex h-40 w-[250px] items-center overflow-hidden rounded-4 border border-solid px-12"
      data-event-name={eventName}
      data-verification-uri={verificationUri}
      data-return-uri={returningUri}
      data-form-location={formLocation}
      data-page={window.location.pathname}
      onClick={() => appleId.auth.signIn()}
    >
      {/* empty div below is used for google sign in styling */}
      <div className="absolute inset-0"></div>
      <img src={appleBlackLogoSrc} className="relative w-[18px]" />
      <div className="font-google-signin relative grow">Continue with Apple</div>
    </button>
  );
}
